/* Dar el Djazair — interactions */
(function () {
  const T = window.DED_T || {};
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  };
  const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    const f = d.querySelector('[data-autofocus]') || d.querySelector('button,a,input'); if (f) setTimeout(() => f.focus(), 50);
  }
  function closeDrawer(d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  document.addEventListener('click', (e) => {
    const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); openDrawer(o.dataset.open); if (o.dataset.open === 'cart-drawer') renderCart(); return; }
    const c = e.target.closest('[data-close]'); if (c) { closeDrawer(c.closest('.drawer')); return; }
    if (e.target.classList && e.target.classList.contains('drawer')) closeDrawer(e.target);
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') $$('.drawer.open').forEach(closeDrawer); });

  let toastTimer;
  function toast(msg) {
    const t = $('#ded-toast'); if (!t) return; t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('show'), 2200);
  }

  function setCount(n) { $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = !n; }); }
  async function getCart() { const r = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  async function renderCart() {
    const body = $('#cart-lines'), foot = $('#cart-foot'); if (!body) return;
    const cart = await getCart(); setCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div class="empty"><div><svg class="icon" style="width:3rem;height:3rem;margin:0 auto .75rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 11h14l-1.5 9h-11z"/><path d="M8 11l4-7 4 7"/></svg><p>' + esc(T.empty) + '</p></div></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    body.innerHTML = cart.items.map((it) => {
      const img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_144x144$1$2') : '';
      return '<div class="cart-line" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div><a href="' + esc(it.url) + '" style="font-weight:600;line-height:1.2;display:block">' + esc(it.product_title) + '</a>' +
        (it.variant_title ? '<p class="text-muted" style="font-size:.8rem">' + esc(it.variant_title) + '</p>' : '') +
        '<p class="text-clay" style="font-size:.875rem;margin-top:.25rem">' + money(it.final_price) + '</p>' +
        '<div class="qty"><button type="button" data-q="-1" aria-label="' + esc(T.dec) + '">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="' + esc(T.inc) + '">+</button></div></div>' +
        '<button type="button" class="btn-icon btn" style="background:none" data-remove aria-label="' + esc(T.remove) + '"><svg class="icon-sm" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg></button></div>';
    }).join('');
    $('#cart-total').textContent = money(cart.total_price);
    const ship = $('[data-ship]', foot);
    if (ship) {
      const th = parseInt(ship.dataset.threshold, 10) || 8000;
      const left = Math.max(0, th - cart.total_price);
      const txt = $('[data-ship-text]', ship), bar = $('[data-ship-bar]', ship);
      if (txt) txt.innerHTML = left > 0 ? ship.dataset.msgLeft.replace('{amount}', esc(money(left))) : ship.dataset.msgOk;
      if (bar) bar.style.width = Math.min(100, Math.round(cart.total_price * 100 / th)) + '%';
    }
  }
  async function changeLine(key, qty) {
    await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
    renderCart();
  }
  document.addEventListener('click', (e) => {
    const line = e.target.closest('.cart-line'); if (!line) return;
    const key = line.dataset.key;
    if (e.target.closest('[data-remove]')) return changeLine(key, 0);
    const q = e.target.closest('[data-q]');
    if (q) { const cur = parseInt(line.querySelector('.qty span').textContent, 10); changeLine(key, Math.max(0, cur + parseInt(q.dataset.q, 10))); }
  });
  async function addToCart(id, quantity, btn) {
    if (btn) btn.disabled = true;
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }] }) });
      const data = await r.json();
      if (!r.ok) { toast(data.description || T.error); return; }
      toast(T.added); const cart = await getCart(); setCount(cart.item_count);
      if (btn && btn.classList.contains('add-round')) { btn.classList.add('done'); setTimeout(() => btn.classList.remove('done'), 1200); }
      if (btn && btn.dataset.openCart !== undefined) { openDrawer('cart-drawer'); renderCart(); }
    } finally { if (btn) btn.disabled = false; }
  }
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-quick-add]'); if (!b) return; e.preventDefault(); addToCart(b.dataset.quickAdd, 1, b);
  });
  $$('form[data-product-form]').forEach((f) => f.addEventListener('submit', (e) => {
    e.preventDefault(); const fd = new FormData(f); addToCart(fd.get('id'), fd.get('quantity'), f.querySelector('[type=submit]'));
  }));

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-step]'); if (!b) return;
    const input = b.parentElement.querySelector('input'); input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
  });

  const vjson = $('#ded-variants');
  if (vjson) {
    const variants = JSON.parse(vjson.textContent);
    const form = $('form[data-product-form]');
    const update = () => {
      const opts = $$('.variant-picker fieldset').map((fs) => { const c = fs.querySelector('input:checked'); return c ? c.value : null; });
      const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
      if (!v) return;
      form.querySelector('[name=id]').value = v.id;
      const p = $('[data-price]'); if (p) p.textContent = money(v.price);
      const btn = form.querySelector('[type=submit]'); btn.disabled = !v.available;
      btn.querySelector('span').textContent = v.available ? T.add : T.soldout;
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.featured_image) { const m = $('.pdp-media img.main'); if (m) { m.src = v.featured_image.src; m.srcset = ''; } }
    };
    $$('.variant-picker input').forEach((i) => i.addEventListener('change', update));
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-thumb]'); if (!t) return;
    const m = $('.pdp-media img.main'); m.src = t.dataset.thumb; m.srcset = '';
    $$('[data-thumb]').forEach((x) => x.classList.toggle('active', x === t));
  });

  const sInput = $('#ded-search-input'), sOut = $('#ded-predict');
  let sTimer;
  if (sInput && sOut) sInput.addEventListener('input', () => {
    clearTimeout(sTimer);
    const q = sInput.value.trim(); if (q.length < 2) { sOut.innerHTML = ''; return; }
    sTimer = setTimeout(async () => {
      const r = await fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8');
      const d = await r.json(); const res = d.resources.results;
      const cols = (res.collections || []).map((c) => '<a href="' + esc(c.url) + '"><span class="chip">' + esc(c.title) + '</span></a>').join('');
      const prods = (res.products || []).map((p) => '<a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" width="48" height="48" loading="lazy">' : '') + '<span><strong style="display:block;font-weight:600">' + esc(p.title) + '</strong><span class="text-clay" style="font-size:.8rem">' + esc(p.price ? money(Math.round(parseFloat(p.price) * 100)) : '') + '</span></span></a>').join('');
      sOut.innerHTML = (cols ? '<div class="chips" style="margin:1rem 0">' + cols + '</div>' : '') + (prods || '<p class="text-muted" style="margin-top:1rem">' + esc(T.noresult) + '</p>');
    }, 220);
  });

  $$('form[data-filters]').forEach((f) => f.addEventListener('change', () => f.submit()));
  $$('select[data-sort]').forEach((s) => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); location.href = u; }));
})();
